// [PHASE-5 2026-10] The school_admin and super_admin dashboards are designed
// for a computer. Below this width they show a notice first, with a
// "Continue anyway" button: a notice, never a block. The choice is remembered
// for the tab (sessionStorage) and forgotten at logout.

export const DESKTOP_MIN_WIDTH = 1024;
export const DESKTOP_NOTICE_DISMISSED_KEY = 'edugate_desktop_notice_dismissed';
export const DESKTOP_FIRST_ROLES = ['super_admin', 'school_admin'];

export function isDesktopFirstRole(role) {
  return DESKTOP_FIRST_ROLES.includes(role);
}

export function shouldShowDesktopNotice(width, dismissed) {
  if (dismissed) return false;
  if (typeof width !== 'number' || !Number.isFinite(width) || width <= 0) return false;
  return width < DESKTOP_MIN_WIDTH;
}

export function readDesktopNoticeDismissed(storage) {
  try {
    return !!storage && storage.getItem(DESKTOP_NOTICE_DISMISSED_KEY) === '1';
  } catch {
    return false;
  }
}

export function rememberDesktopNoticeDismissed(storage) {
  try {
    if (storage) storage.setItem(DESKTOP_NOTICE_DISMISSED_KEY, '1');
  } catch {
    /* storage unavailable: the notice may show again on reload, that is all */
  }
}

export function clearDesktopNoticeDismissed(storage) {
  try {
    if (storage) storage.removeItem(DESKTOP_NOTICE_DISMISSED_KEY);
  } catch {
    /* nothing to clear */
  }
}
